export default "__VITE_ASSET__DC$te1x8__"